import { render } from "./TournamentInfo.vue?vue&type=template&id=60141ec2&scoped=true"
import script from "./TournamentInfo.vue?vue&type=script&lang=js"
export * from "./TournamentInfo.vue?vue&type=script&lang=js"

import "./TournamentInfo.vue?vue&type=style&index=0&id=60141ec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60141ec2"]])

export default __exports__